export const infoContentPeerGroups = [
  {
    title: 'benchmarking.performance_tab.info_content.what_are_peers.title',
    description: 'benchmarking.performance_tab.info_content.what_are_peers.description',
  },
  {
    title: 'benchmarking.performance_tab.info_content.all_peers.title',
    description: 'benchmarking.performance_tab.info_content.all_peers.description',
  },
  {
    title: 'benchmarking.performance_tab.info_content.best_performers_peers.title',
    description: 'benchmarking.performance_tab.info_content.best_performers_peers.description',
  },
  {
    title: 'benchmarking.performance_tab.info_content.direct_peers.title',
    description: 'benchmarking.performance_tab.info_content.direct_peers.description',
  },
  {
    title: 'benchmarking.performance_tab.info_content.industry_peers.title',
    description: 'benchmarking.performance_tab.info_content.industry_peers.description',
  },
];
